import { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { HOME } from 'src/routes/routes';
import { CREATE_AUTHORIZATION_CODE_MUTATION } from 'src/graphql/authorizationCode/mutation';
import { useMutation } from 'src/graphql';
import { setLoginRedirect } from 'src/utils/data/loginRedirect';

export default (targetUrl) => {
  const [redirectUrl, setRedirectUrl] = useState();
  const location = useLocation();
  const [createAuthorizationCode] = useMutation(CREATE_AUTHORIZATION_CODE_MUTATION);
  const createAuthCode = useCallback(async () => {
    try {
      const { data: { createAuthorizationCode: { authorizationCode: {code} } } } = await createAuthorizationCode();
      window.location.href = `${targetUrl}?authorization_code=${code}`;
    }
    catch (e) {
      setLoginRedirect(`${location.pathname}${location.search}`);
      setRedirectUrl(HOME);
    }

  }, [targetUrl]);

  return { redirectUrl, createAuthCode };
};
